export default __webpack_public_path__ + "static/media/12.b930e5f9.png";